import { createContext } from 'react'

type ChildRegistrationContextValue = {
  register: (refGetter: () => HTMLElement[]) => void
  unregister: (refGetter: () => HTMLElement[]) => void
}

export const ChildRegistrationContext =
  createContext<ChildRegistrationContextValue>({
    register: () => {},
    unregister: () => {},
  })
